<template>
  <el-pagination
    v-if="page.total > 0"
    class="pagination"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="page.page"
    :page-sizes="pageSizes"
    :page-size="page.limit"
    :layout="layout"
    :total="page.total"
  >
  </el-pagination>
</template>

<script>
export default {
  props: {
    pageSizes: {
      type: Array,
      default: () => [20, 40, 60, 80]
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    page: {
      type: Object,
      default: () => {
        return {
          total: 0,
          pageNo: 1,
          limit: 20
        };
      }
    },
    getList: {
      typeof: Function
    }
  },
  data() {
    return {};
  },
  methods: {
    handleSizeChange(val) {
      if (this.page.limit) this.page.limit = val;
      else this.page.pageSize = val;
      this.getList({ pageSize: val });
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      console.log("aaaaa", val);
      this.getList({ pageNo: val });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 30px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/commonPagination.vue